<template>
  <div class="page">
    <el-table
      :data="tableData"
      height="505"
      border
      style="width: 98%; overflow: auto"
    >
      <el-table-column prop="title" label="文章标题" width="500">
        <template slot-scope="scope">
          <span
            @click="jumpDetails(scope.row.id)"
            v-html="scope.row.title"
            class="title"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="sourceFrom" label="来源" width="200">
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="200"> </el-table-column>
      <el-table-column prop="publishTime" label="最新发布时间" width="200">
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button
            @click="handleUpdate(scope.row.id)"
            type="text"
            size="small"
            >修改
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="修改" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <updateRotationPanel
        v-if="dialogFormVisible"
        :id="infoId"
      ></updateRotationPanel>
    </el-dialog>
  </div>
</template>

<script>
import { getRotationAll } from "@/api/api";
import updateRotationPanel from "@/components/updateRotationPanel.vue";
export default {
  components: { updateRotationPanel },
  data() {
    return {
      tableData: [],
      dialogFormVisible: false,
      infoId: "",
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    jumpDetails(id) {
      let routerUrl = this.$router.resolve({
        path: "/articleDetails",
        query: { id },
      });
      window.open(routerUrl.href);
    },
    // 获取表格数据
    getTableData() {
      getRotationAll({}).then((res) => {
        if (res.data.code === 200) {
          this.tableData = res.data.data;
        }
      });
    },
    handleUpdate(id) {
      this.infoId = id;
      this.dialogFormVisible = true;
    },
    handleClose() {
      this.getTableData();
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  position: relative;
  width: 100%;
  height: 100%;
  .pagination {
    width: 100%;
    margin-top: 10px;
    text-align: right;
    padding-right: 20px;
  }
}

.title {
  cursor: pointer;
  &:hover {
    color: #13509f;
  }
}
</style>
